import VideoPlayerContext from './VideoPlayerContext'
export { useVideoPlayerContext } from './VideoPlayerContext'
export { AUTO_BITRATE } from './reducer'

export default VideoPlayerContext
